import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  Button,
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  // Accordion,
  // AccordionSummary,
  // AccordionDetails,
  Typography,
} from '@mui/material';
import  {
  PictureAsPdf,
  Image,
  Download,
  Visibility,
} from '@mui/icons-material';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "../accordion";
import {
  FormInputDropdown,
  FormInputText,
} from "../form";
import {
  DialogTitleClose,
  PaperComponent,
} from "../dialog";
import * as gunitActions from "../../store/gunit";

// 아래 form components의 name과 연계
const defaultValues = {
  id: "",
  fromGClient: "",
  toGClient: "",
  subject: "",
  html: "",
};

const mobileDialogTitleSx = {
  position: 'relative',
  fontSize: '18px !important',
  fontWeight: '600 !important',
  lineHeight: 1.3,
  padding: '16px 56px 16px 16px !important',
  '& .MuiIconButton-root[aria-label="close"]': {
    marginTop: '0 !important',
    top: '50%',
    transform: 'translateY(-50%)',
  },
};

const GSendG04docuDialog = ({
  crudMode,
  open,
  setOpen,
  selectedRow,
  handleClickDownloadAttachFile,
  fullScreen = false,
  onViewDocument,
  onOpenMail,
  onDelete,
}) => {
  // TODO : extend가 의미가 맞는 거 같다.
  const [expanded, setExpanded] = useState(false);

  const { handleSubmit, reset, control, setValue } = useForm({ defaultValues: defaultValues });

  const handleDialogClose = () => {
    setOpen(false);
  };

  useEffect(
    () => {
      console.log(selectedRow);
      if (selectedRow) {
        for (const [item, value] of Object.entries(defaultValues)) {
          setValue(item, selectedRow[item] || value);
        }
      }

      if (fullScreen || (selectedRow.attachments && selectedRow.attachments.length <= 5)) {
        setExpanded(true);
      }
    }
    , [selectedRow, fullScreen]
  );

  const renderAttachmentList = () => {
    if (!selectedRow.attachments || selectedRow.attachments.length === 0) return null;
    return selectedRow.attachments.map((file) => {
      const { filename, path } = file;
      const name = filename || '(파일)';
      const pos = name.lastIndexOf(".");
      let ext = "";
      if (pos > -1) {
        ext = name.substring(pos + 1);
      }
      const fileIcon = ext.toLowerCase() === 'pdf' ? <PictureAsPdf /> : <Image />;

      if (fullScreen) {
        return (
          <ListItem key={path || name} disablePadding sx={{ py: 0.5 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>{fileIcon}</ListItemIcon>
            <ListItemText primary={name} sx={{ my: 0, pr: 1, '& .MuiListItemText-primary': { wordBreak: 'break-all' } }} />
            <Tooltip title={"받기"}>
              <IconButton aria-label="받기" onClick={(e) => handleClickDownloadAttachFile(e, path)}>
                <Download />
              </IconButton>
            </Tooltip>
            {onViewDocument && (
              <Tooltip title={"문서 보기"}>
                <IconButton aria-label="문서 보기" onClick={() => onViewDocument(path)}>
                  <Visibility />
                </IconButton>
              </Tooltip>
            )}
          </ListItem>
        );
      }

      return (
        <ListItem key={path || name} disablePadding>
          <Tooltip title={"다운로드"}>
            <ListItemButton onClick={(e) => handleClickDownloadAttachFile(e, path)}>
              <ListItemIcon>
                {fileIcon}
              </ListItemIcon>
              <ListItemText primary={name} />
            </ListItemButton>
          </Tooltip>
        </ListItem>
      );
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      PaperComponent={fullScreen ? undefined : PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullScreen={fullScreen}
      PaperProps={fullScreen ? { sx: { display: 'flex', flexDirection: 'column' } } : undefined}
    >
      <DialogTitleClose
        id="draggable-dialog-title"
        onClose={handleDialogClose}
        style={fullScreen ? undefined : { cursor: 'move' }}
        sx={fullScreen ? mobileDialogTitleSx : undefined}
      >
        { crudMode === 'R' && "메일 상세"}
      </DialogTitleClose>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ display: 'none'}}>
            <FormInputText
              name={"id"}
              control={control}
              label={"아이디"}
              inputProps={
                { readOnly: true }
              }
            />
          </Grid>
          <Grid item xs={12}>
            <FormInputText
              name={"fromGClient"}
              control={control}
              label={"보낸 거래선"}
              inputProps={
                { readOnly: crudMode === 'R' }
              }
            />
          </Grid>
          <Grid item xs={12}>
            <FormInputText
              name={"toGClient"}
              control={control}
              label={"받은 거래선"}
              inputProps={
                { readOnly: crudMode === 'R' }
              }
              // InputProps={{
              //   inputComponent: NumberFormatCustom,
              //   inputProps: {
              //     style: { textAlign: "right" },
              //   }
              // }}
            />
          </Grid>
          <Grid item xs={12}>
          {
            selectedRow.mailTo && selectedRow.mailTo.length > 0 ? (
              <FormInputText
                name={"mailTo"}
                control={control}
                label={"받은 사람"}
                inputProps={{ readOnly: crudMode === 'R', style: { display: 'none' } }}
                InputProps={{ 
                  startAdornment: (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, width: '100%'}}> 
                      {selectedRow.mailTo.map(to => (
                        <Chip label={to.name} size="small" sx={{ m: 0.5 }} />
                      ))}
                    </Box>
                  ),
                }}
                sx={{
                  '& .MuiInputBase-root': {
                    display: 'flex',
                    flexWrap: 'wrap',
                    padding: '4px'
                  }
                }}
              />
            ) : (
              <FormInputText
                name={"mailTo"}
                control={control}
                label={"받은 사람"}
                inputProps={{ readOnly: crudMode === 'R' }}
              />
            )
          }
          </Grid>
          <Grid item xs={12}>
            {
              selectedRow.mailCc && selectedRow.mailCc.length > 0 ? (
                <FormInputText
                  name={"mailCc"}
                  control={control}
                  label={"참조"}
                  inputProps={{ readOnly: crudMode === 'R', style: { display: 'none' } }}
                  InputProps={{ 
                    startAdornment: (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, width: '100%'}}> 
                        {selectedRow.mailCc.map(cc => (
                          <Chip label={cc.name} size="small" sx={{ m: 0.5 }} />
                        ))}
                      </Box>
                    ),
                  }}
                />) : (
                <FormInputText
                  name={"mailCc"}
                  control={control}
                  label={"참조"}
                  inputProps={{ readOnly: crudMode === 'R' }}
                />
              )
            }
          </Grid>
          <Grid item xs={12}>
            {
              selectedRow.mailCcInternal && selectedRow.mailCcInternal.length > 0 ? (
                <FormInputText
                  name={"mailCcInternal"}
                  control={control}
                  label={"내부참조"}
                  inputProps={{ readOnly: crudMode === 'R', style: { display: 'none' } }}
                  InputProps={{ 
                    startAdornment: (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, width: '100%'}}> 
                        {selectedRow.mailCcInternal.map(ccInternal => (
                          <Chip label={ccInternal.name} size="small" sx={{ m: 0.5 }} />
                        ))}
                      </Box>
                    ),
                  }}
                />) : (
                  <FormInputText
                    name={"mailCcInternal"}
                    control={control}
                    label={"내부참조"}
                    inputProps={{ readOnly: crudMode === 'R' }}
                  />
              )
            }
          </Grid>
          <Grid item xs={12}>
            <FormInputText
              name={"subject"}
              control={control}
              label={"제목"}
              inputProps={
                { readOnly: crudMode === 'R' }
              }
            />
          </Grid>
          <Grid item xs={12}>
          <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
              <AccordionSummary aria-controls="basic-content" id="basic-header">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body" component="div">{`메시지`}</Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  component="div"
                  dangerouslySetInnerHTML={{ __html: selectedRow.html }}
                  sx={{
                    whiteSpace: 'normal', // 줄바꿈 허용
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12}>
            {fullScreen ? (
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                  {`첨부파일 (${selectedRow.attachments && selectedRow.attachments.length ? selectedRow.attachments.length : 0})`}
                </Typography>
                {renderAttachmentList()}
              </Box>
            ) : (
            <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
              <AccordionSummary aria-controls="basic-content" id="basic-header">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body" component="div">{`첨부파일 (${selectedRow.attachments && selectedRow.attachments.length ? selectedRow.attachments.length : 0})`}</Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                {renderAttachmentList()}
              </AccordionDetails>
            </Accordion>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={fullScreen ? {
          '&&': {
            padding: '12px 16px calc(12px + env(safe-area-inset-bottom)) !important',
            gap: '12px',
          },
        } : undefined}
      >
        {fullScreen && onOpenMail && (
          <Button
            variant="contained"
            onClick={onOpenMail}
            sx={{ flex: 1, height: 44, marginLeft: '0 !important' }}
          >
            {"전달"}
          </Button>
        )}
        {fullScreen && onDelete && (
          <Button
            variant="outlined"
            color="error"
            onClick={onDelete}
            sx={{ flex: 1, height: 44, marginLeft: '0 !important' }}
          >
            {"삭제"}
          </Button>
        )}
        <Button
          onClick={handleDialogClose}
          variant={fullScreen ? 'outlined' : 'text'}
          sx={fullScreen ? { flex: 1, height: 44, marginLeft: '0 !important' } : undefined}
        >
          {"닫기"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GSendG04docuDialog;
